export default __webpack_public_path__ + "static/datelabel-dropdown-do-1-light-030e4e631478e9ea20250694d28881e71ae78f4723164dfa7f2aae13a632f1b7.png";